module.exports = __webpack_public_path__ + "static/media/burgerBuilder.589ab2ab.png";